import { AxiosPromise } from 'axios';

import { vaultApi } from '../api';
import { IApiResponse } from '../interfaces';
import {
  IExchangeSchedule,
  IExchangeSchedulePayload,
  IGameId,
} from './interfaces';

const basePath = '/exchangeSchedule';
const gameIdPath = '/gameId';
const scheduleTeamPath = `${basePath}/team`;

/* eslint-disable implicit-arrow-linebreak */

export const getSchedules = (byOrg: boolean = true, gameDate: string = '', sport: string = '', league: string = '', season: string = ''): AxiosPromise<IApiResponse<Array<IExchangeSchedule>>> =>
  vaultApi.getInstance().get(`${basePath}?org=${byOrg ? 'true' : 'false'}&gameDate=${gameDate}&sport=${sport}&league=${league}&season=${season}`);

export const getTeamSchedule = (teamId: string): AxiosPromise<IApiResponse<Array<IExchangeSchedule>>> =>
  vaultApi.getInstance().get(`${scheduleTeamPath}/${teamId}`);

export const updateSchedule = (id: string, payload: IExchangeSchedulePayload): AxiosPromise<IApiResponse<IExchangeSchedule>> =>
  vaultApi.getInstance().put(`${basePath}/${id}?reorder`, payload);

export const deleteSchedule = (id: string, hard: boolean = false): AxiosPromise<any> =>
  vaultApi.getInstance().delete(`${basePath}/${id}?hard=${hard}`);

export const createGame = (payload: IExchangeSchedulePayload): AxiosPromise<IApiResponse<IExchangeSchedule>> =>
  vaultApi.getInstance().post(basePath, payload);

export const getGameId = (season: string, sport: string, league: string): AxiosPromise<IApiResponse<IGameId>> =>
  vaultApi.getInstance().get(`${gameIdPath}?season=${season}&sport=${sport}&league=${league}`);

export const gameIdInUse = (gameId: string, sport: string, league: string): AxiosPromise<IApiResponse<boolean>> =>
  vaultApi.getInstance().get(`${gameIdPath}/in-use?gameId=${gameId}&sport=${sport}&league=${league}`);

export const getTeamGameNumber = (teamId: string, season: string, gameDate: string) => vaultApi.getInstance().get(`${scheduleTeamPath}/${teamId}/teamGameNumber?season=${season}&gameDate=${gameDate}`);

export const getScheduleById = (id: string): AxiosPromise<IApiResponse<IExchangeSchedule>> =>
  vaultApi.getInstance().get(`${basePath}/${id}`);
